export function EditDataTypeRequestObject(this: any): any {
  return {
    id: this.id,
    name: this.name,
    storedProcedure: this.storedProcedure,
    description: this.description,
  };
}
